import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import * as TanStackQueryProvider from "./integrations/tanstack-query/root-provider.tsx";
import { createAppRouter } from "./router.tsx";

import "./styles.css";

const TanStackQueryProviderContext = TanStackQueryProvider.getContext({
	// the session expired while browsing: sign in again, then come back here
	onUnauthorized: () => {
		const { pathname, href } = router.state.location;
		if (!pathname.startsWith("/connexion"))
			router.navigate({ to: "/connexion", search: { redirect: href } });
	},
});
const router = createAppRouter(TanStackQueryProviderContext);

const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
				<RouterProvider router={router} />
			</TanStackQueryProvider.Provider>
		</StrictMode>,
	);
}
